import { useState } from 'react';
import { z } from 'zod';
import { GridColumnResizeParams } from '@rossum/ui/x-data-grid-pro';
import { parseAndValidate } from '../../../../../utils/jsonParse';

const ACTIVITIES_COLUMNS_WIDTHS_KEY = 'activities:columnWidths';

const columnWidthsSchema = z
  .object({
    status: z.number(),
    source: z.number(),
    duration: z.number(),
    start: z.number(),
    end: z.number(),
    annotation: z.number(),
    message: z.number(),
  })
  .partial();

export type ColumnWidthsObject = z.infer<typeof columnWidthsSchema>;

export const useColumnWidths = () => {
  const [state, setState] = useState(
    parseAndValidate(
      localStorage.getItem(ACTIVITIES_COLUMNS_WIDTHS_KEY),
      columnWidthsSchema,
      {}
    )
  );

  const handleSetState = ({ colDef, width }: GridColumnResizeParams) => {
    const newState = { ...state, [colDef.field]: width };

    setState(newState);
    localStorage.setItem(
      ACTIVITIES_COLUMNS_WIDTHS_KEY,
      JSON.stringify(newState)
    );
  };

  return {
    columnWidths: state,
    setColumnWidths: handleSetState,
  };
};
